import React, { useState } from "react"
import { Link } from "gatsby"
import styles from './navbar.module.css'
import logo from "../assets/hiroshimageisenn-logo-transparent.png"
import {AnchorLink} from "gatsby-plugin-anchor-links"

export default function Navbar()
{
    const [clicked, setClicked] = useState(styles.hamburger)
    const [dropdown, setDropdown] = useState(styles.hideDropdown)

    return(
        <div className = {styles.navbar}>
            <nav className = {styles.nav}>
                <h1 className = {styles.navHeader}>
                    <Link href = "/"><a><img src={logo} alt="hiroshimageisenn logo" className={styles.logo}></img></a></Link> 
                </h1>
                <div onClick={()=>{
                    var newClick = clicked === styles.hamburger ? styles.hamburgerClicked : styles.hamburger; setClicked(newClick);
                    var dd = dropdown === styles.hideDropdown ? styles.showDropdown : styles.hideDropdown; setDropdown(dd);
                    }} className = {styles.hamburgerHolder}>
                    <div className={clicked}></div>
                    <div className={clicked}></div>
                    <div className={clicked}></div>
                </div>
            </nav>
            <div className = {styles.dropdown + ' ' + dropdown}>
                <div className={styles.ddLink}><Link href="/" className={styles.link}>News</Link></div>
                <div className={styles.ddLink}><Link href="/exhibitions" className={styles.link}>Exhibitions</Link></div>
                <div className={styles.ddLink}><Link href="/about" className={styles.link}>About</Link></div>
                <div className={styles.ddLink}><a href="https://www.facebook.com/hiroshima.art/?ref=page_internal" className={styles.link} target = "_blank">Facebook</a></div>
                <div className={styles.ddLink}><a href="https://www.youtube.com/channel/UCX2J5F_wd70ZllCxS163OJg" className={styles.link} target = "_blank">Youtube</a></div>
                <div className={styles.ddLink}><AnchorLink to="/about#contact" className={styles.link}>Contact</AnchorLink></div>
            </div>
        </div>
    )
}

const NavLinks = [
    {
        text: 'News',
        link: '/',
    },
    {
        text: 'Exhibitions',
        link: '/exhibitions',
    },
    {
        text: 'About',
        link: '/about',
    },
    {
        text: 'Contact',
        link: '/about/#contact',
    },
]